import { Component } from '@angular/core';

@Component({
  selector: 'app-compat-navigation',
  template: ''
})
export class CompatNavigationComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/compat/compat-navigation.component.ts